import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog, CircularProgress, DialogContent } from '@mui/material';

import ButtonExportExcel from '../Button/ButtonExportExel';
import { api, config } from '../../configs';
import ExcelSheetGenerator from './ExcelSheetGenerator';

const ExportExcelHistory = ({
  currentData,
  dataAPIEndPoint,
  dataQuery = {},
  sheetName,
  columnList,
  columnDataList,
  disableAllExport = false,
  buttonSize = 'medium',
  spreadedColumn = '',
}) => {
  const [dialogOpen, setDialogOpen] = useState();
  const [excelData, setExcelData] = useState();
  const [excelDataAll, setExcelDataAll] = useState();

  console.log('excelData', excelData);
  console.log('currentData', currentData);
  console.log('columnDataList', columnDataList);
  console.log('columnList', columnList);

  const handleAllDownload = async () => {
    try {
      if (dataQuery && !dataQuery?.size) {
        // eslint-disable-next-line no-param-reassign
        dataQuery.size = config.maxFetchSize;
      }
      const searchParam = new URLSearchParams(dataQuery);
      setDialogOpen(true);
      const { data } = await api.get(
        `${
          process.env.REACT_APP_API_URL
        }/${dataAPIEndPoint}/?${searchParam.toString()}`,
      );

      setExcelData(data?.rows);
      setDialogOpen(false);
    } catch (error) {
      alert(`ไม่สามารถดาวน์โหลดไฟล์ Excel ได้ ${error?.message}`);
    }
  };

  const handleAllDataDownload = async () => {
    try {
      if (dataQuery && !dataQuery?.size) {
        // eslint-disable-next-line no-param-reassign
        dataQuery.size = config.maxFetchSize;
      }
      const searchParam = new URLSearchParams(dataQuery);
      setDialogOpen(true);
      const { data } = await api.get(
        `${
          process.env.REACT_APP_API_URL
        }/${dataAPIEndPoint}/?${searchParam.toString()}`,
      );

      setExcelDataAll(data?.rows);
      setDialogOpen(false);
    } catch (error) {
      alert(`ไม่สามารถดาวน์โหลดไฟล์ Excel ได้ ${error?.message}`);
    }
  };

  const handleCurrentDownload = () => {
    setExcelData(currentData);
  };

  useEffect(() => {
    let interval = () => {};
    if (excelData) {
      interval = setInterval(() => {
        setExcelData();
      }, 1000);
    }

    return () => {
      clearInterval(interval);
    };
  }, [excelData]);

  return (
    <div className="">
      <Dialog open={dialogOpen}>
        <DialogContent>
          <div className="flex justify-center">
            <CircularProgress />
          </div>
          <div>กำลังเตรียมข้อมูลสำหรับการดาวน์โหลด</div>
        </DialogContent>
      </Dialog>
      {excelData ? (
        <ExcelSheetGenerator
          columnList={columnList}
          columnDataList={columnDataList}
          dataSets={excelData}
          sheetName={sheetName}
          spreadedColumn={spreadedColumn}
          type={'excelData'}
        />
      ) : (
        <div></div>
      )}
      {excelDataAll ? (
        <ExcelSheetGenerator
          columnList={columnList}
          columnDataList={columnDataList}
          dataSets={excelDataAll}
          sheetName={sheetName}
          spreadedColumn={spreadedColumn}
          type={'excelDataAll'}
        />
      ) : (
        <div></div>
      )}
      <ButtonExportExcel
        handleAllDownload={handleAllDownload}
        handleAllDataDownload={handleAllDataDownload}
        handleCurrentDownload={handleCurrentDownload}
        disableAllExport={disableAllExport}
        buttonSize={buttonSize}
      />
    </div>
  );
};

ExportExcelHistory.propTypes = {
  currentData: PropTypes.arrayOf(PropTypes.object),
  dataAPIEndPoint: PropTypes.string,
  dataQuery: PropTypes.object,
  sheetName: PropTypes.string,
  columnList: PropTypes.arrayOf(PropTypes.object),
  disableAllExport: PropTypes.bool,
  buttonSize: PropTypes.string,
  spreadedColumn: PropTypes.string,
  columnDataList: PropTypes.arrayOf(PropTypes.object),
};

export default ExportExcelHistory;
